<template>
  <div v-if="getSellers">
    <v-tabs v-model="tab" grow>
      <v-tab v-for="item in items" :key="item.tab">{{ item.tab }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.tab">
        <v-card
          class="seller"
          v-for="seller in sellers(item.tab)"
          :key="seller.id"
          @click="cardClicked(seller.id)"
        >
          <v-card-title>{{ seller.name }}</v-card-title>
          <v-card-subtitle v-if="seller.location"
            >Location: {{ seller.location }},
            {{ seller.qty }} items</v-card-subtitle
          >
          <v-card-subtitle v-else> {{ seller.qty }} items</v-card-subtitle>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Sellers",
  data() {
    return {
      tab: null,
      items: [{ tab: "Euromoda" }, { tab: "Eurotrans" }],
      sellersInEuromoda: [
        { id: 25, location: "A 052", tag: "top alice" },
        { id: 28, location: "B 047", tag: "foot culture" },
        { id: 35, location: "B 006-007", tag: "parismoi" },
        { id: 36, location: "B 019", tag: "kayla" },
        { id: 49, location: "A 016", tag: "yike" },
        { id: 53, location: "A 021", tag: "ai river gmbh" },
        { id: 64, location: "A 012-013", tag: "silvio" },
        { id: 66, location: "A 002", tag: "lujah" },
        { id: 67, location: "B 242-245", tag: "cl trading" },
        { id: 68, location: "B 019", tag: "Blila" },
        { id: 69, location: "B 015-016", tag: "just lili" },
        { id: 71, location: "A 213-215", tag: "skyflame" },
        { id: 75, location: "B 013", tag: "mc" },
        { id: 76, location: "A 053", tag: "muse" },
        { id: 78, location: "B 020", tag: "light blue" },
        { id: 82, location: "B 014-012", tag: "huada" },
        { id: 100, location: "A 002", tag: "lujah" },
        { id: 106, location: "B 006-007", tag: "parismoi" }
      ]
    };
  },
  computed: {
    ...mapGetters(["getSellers"])
  },
  created: function() {
    this.$store.dispatch("getExpectedFromServer").catch(err => {
      console.log(err.response);
    });
  },
  methods: {
    cardClicked(sellerId) {
      this.$store.commit("SHOW_SEARCHBAR", true);
      this.$router.push("/sellers/" + sellerId);
    },

    sellers(tab) {
      let result = [];
      let euromoda = false;
      console.log("Aantal sellers:" + this.getSellers.length);
      console.log(
        "Aantal sellers in Euromoda:" + this.sellersInEuromoda.length
      );

      if (tab == "Euromoda") {
        for (let i = 0; i < this.getSellers.length; i++) {
          for (let a = 0; a < this.sellersInEuromoda.length; a++) {
            if (this.getSellers[i].id == this.sellersInEuromoda[a].id) {
              result.push({
                tab: "Euromoda",
                id: this.getSellers[i].id,
                name: this.getSellers[i].name,
                qty: this.getSellers[i].qty,
                location: this.sellersInEuromoda[a].location
              });
            }
          }
        }
      } else {
        for (let i = 0; i < this.getSellers.length; i++) {
          for (let a = 0; a < this.sellersInEuromoda.length; a++) {
            if (this.getSellers[i].id == this.sellersInEuromoda[a].id) {
              euromoda = true;
            }
          }
          if (euromoda == true) {
            euromoda = false;
          } else {
            result.push({
              tab: "Eurotrans",
              id: this.getSellers[i].id,
              name: this.getSellers[i].name,
              qty: this.getSellers[i].qty
            });
          }
        }
      }
      return result;
    }
  }
};
</script>

<style scoped>
.seller {
  margin: auto;
  margin-top: 4px;
  margin-bottom: 4px;
  width: 80%;
}
</style>
